import DocumentosService from "../api/Documentos/api-documentos";
import fileDownload from "js-file-download";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const DownloadFile = async (documentoURL) => {
    const data = await DocumentosService.consultarArchivo(documentoURL);
    fileDownload(data.data, documentoURL);
}

export const DownloadHTML = (html: any) => {
    html2canvas(html)
      .then((canvas) => {
        let imgWidth = 208;
        let imgHeight = canvas.height * imgWidth / canvas.width;
        const imgData = canvas.toDataURL('img/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save("download.pdf");
      })
    ;
}